import React from "react";
import { formatPhone } from "../../../utils/FormatPhone";
import { capitalizeFirstLetter } from "../../../utils/CapitalizeFirstLetter";
import { formatOwnCollectStartAndEnd } from "../../../utils/OwnCollectTime";
import { RouteOwnCollectStatusEnum } from "../../../enums/RouteOwnCollectStatusEnum";
import IconOptionsEnum from "../../../enums/IconOptionsEnum";

export default function CollectInfo({ loc }) {
  const getStatusColor = (status) => {
    const statusId = status?.length ? status[1]?.id : null
    switch (statusId) {
      case 11:
        return IconOptionsEnum.DELIVERED_OWN_COLLECT.color;
      case 12:
      case 13:
        return IconOptionsEnum.PENDING_OWN_COLLECT.color;
      default:
        return IconOptionsEnum.UNDELIVERED_OWN_COLLECT.color;
    }
  }

  const status = Object.entries(RouteOwnCollectStatusEnum).find(
    st => st[1].id === loc?.status
  );

  const statusColor = getStatusColor(status);

  const title = capitalizeFirstLetter(loc?.client || loc?.origin_or_destination || loc?.driver_name)
  return (
    <div
      style={{
        padding: "0 10px 10px 10px",
        backgroundColor: "#FFF",
        zIndex: 900000000
      }}
    >
      <div style={{
        maxWidth: "420px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}>
        {title && <h4>{title}</h4>}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "8px"
        }}
        >
          {status && status.length && <strong style={{ color: statusColor, fontSize: "16px" }}>{status[1]?.name}</strong>}
          <strong style={{ color: "#409e6a", fontSize: "16px" }}>Coleta Própria</strong>
        </div>
        {loc?.order !== undefined && <div>
          <strong style={{ fontSize: "14px" }}>Ordem: {loc?.order}</strong>
        </div>}
        {loc?.id_route !== undefined && <div>
          <strong style={{ fontSize: "14px" }}>Rota: {loc?.id_route}</strong>
        </div>}

        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {(loc?.startHour || loc?.endHour) && <span style={{ fontSize: "14px" }}><strong>Horário da coleta:</strong> {formatOwnCollectStartAndEnd(loc?.startHour, loc?.endHour)}</span>}
          {loc?.distance && <span style={{ fontSize: "14px" }}><strong>Distância até o próximo ponto:</strong> {loc?.distance} KM</span>}
          {loc?.client_email && <span style={{ fontSize: "14px" }}><strong>Email:</strong> {loc?.client_email}</span>}
          {loc?.client_phone && <span style={{ fontSize: "14px" }}><strong>Tel.:</strong> {formatPhone(loc?.client_phone)}</span>}
          {loc?.id && <span style={{ fontSize: "14px" }}><strong>Coleta:</strong> {loc?.id}</span>}
          {loc?.address && <p style={{ fontSize: "14px" }}><strong>Endereço:</strong> {loc?.address}</p>}
        </div>
      </div>
    </div>
  )
}
